exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".color-circle[data-v-b74c97ec] {\n  height: 1rem;\n  width: 1rem;\n  border-radius: 2rem;\n}\n.color-circle[data-color=\"blue\"][data-v-b74c97ec] {\n    background-color: #ACD2E3;\n}\n.color-circle[data-color=\"green\"][data-v-b74c97ec] {\n    background-color: #55A086;\n}\n", ""]);

